import { stringify } from 'qs';
import { navigateToPage } from '@cian/valuation-utils-component';

import { TThunkAction } from '../../types/redux';

export const handleRedirectToJkEstimator = (): TThunkAction => (dispatch, getState) => {
  const {
    filters: { address, jkRoomsCount, newbuildingId },
  } = getState();

  const queryString = stringify({
    address,
    jkRoomsCount,
    newbuildingId,
  });

  navigateToPage(`/kalkulator-nedvizhimosti/?${queryString}`);
};
